import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SignInForm from "./SignInForm";

interface GuestSignInModalProps {
  open: boolean;
  onClose: () => void;
}

const GuestSignInModal: React.FC<GuestSignInModalProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm")); // fullScreen on small devices

  return (
    <Dialog
      open={open}
      onClose={onClose}
      // fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .css-16htz67-MuiPaper-root-MuiDialog-paper ": {
          borderRadius: "14px !important",
        },
      }}
    >
      <SignInForm text="You're currently accessing as a visitor. Please sign in or create an account to continue." />
    </Dialog>
  );
};

export default GuestSignInModal;
